import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { AppService } from '../../app.service';
import { equipmentListVM, InspectionReportingContainers } from '../component-forecast/component-forecast.model';
import { ComponentForecastService } from '../component-forecast/component-forecast.service';
import { CustomerContactService } from '../customer-contact/add-new-user-cl/customer-contact.service';
import { crsfNewVM, CustomerIdAndNameDataSet } from '../customer-contact/Models/customer-contact.model';
import { NewInspectionService } from '../GET_NEW_UI/inspections/inpsection.service';
import { InspectedComponentsOnImplementViewModel, InspectedImplementsViewModel, InspectionObservationPointsViewModel, InspectionRequestModel, ObservationListRental } from '../GET_NEW_UI/inspections/inspection.model';
import { CustomerService } from '../GET_NEW_UI/services/customer.service';
import { InterpretationService } from '../interpretation/interpretation.service';
import { ComponentModel, GETImplementReport, GETImplementVM, Implement, ImplementSerialVM, RentInterpVM, UndercarriageImplementReport } from '../interpretation/models/interpretation.model';
import { ManageEquipmentService } from '../manage-equipment/manage-equipment.service';
import { ComponentDetails, EquipmentDetails, Inspection, SystemDetails } from '../manage-equipment/models/manage-equipment.model';
import { AddAdditionalAttachmentComponent } from './add-additional-attachment/add-additional-attachment.component';
import { InterpretationreportService } from './interpretationreport.service';
import { ReportContactDialogComponent } from './report-contact-dialog/report-contact-dialog.component';
import { SendHirereportDialogComponent } from './send-hirereport-dialog/send-hirereport-dialog.component';
import { FileReaderEvent } from '../GET_NEW_UI/setup-implement/setup-implement.component';
import { AddAdditionalAttachmentGETComponent } from './add-additional-attachment-get/add-additional-attachment-get.component';
import moment from 'moment';

@Component({
  selector: 'app-inspection-reporting-module',
  templateUrl: './inspection-reporting-module.component.html',
  styleUrls: ['./inspection-reporting-module.component.scss']
})
export class InspectionReportingModuleComponent implements OnInit {
  currentStep: number = 0;
  constructor(private _customerContactService: CustomerContactService,
    private _customerService: CustomerService,
    public _fleetService: ComponentForecastService,
    private _sanitizer: DomSanitizer,
    private _manageEquipService: ManageEquipmentService,
    private _interp: InterpretationService,
    private route: ActivatedRoute,
    private _inspectionService: NewInspectionService,
    private _interpretationReportService: InterpretationreportService,
    private _appService: AppService,

    public dialog: MatDialog) { }


  //appUris: AppUris;
  selectedCustomer: number
  selectedSiteId: number
  selectedEQId: number
  inspectionType: number
  inspectionType_: number[];

  CustomerList: CustomerIdAndNameDataSet[]
  jobsitebyCustomerID: crsfNewVM[]
  JobsiteList: crsfNewVM[];
  equipmnentList: equipmentListVM[]
  equipmentDetails: EquipmentDetails;
  Checkbox_Undercarriage = true
  Checkbox_GET = false
  preDeliveryInspectionDate
  postDeliveryInspectionDate
  InspetionLabel
 
  Comment
  isShowUndercarriageTable: boolean = false
  isShowUndercarriageTab: boolean = false
  isShowGetImplementTable: boolean = false
  isShowgetImplementTab: boolean = false
  isShowDigitalFormTab: boolean = false
  isShowDigitalFormTable: boolean = false
  IsRSH: boolean = false;
  AddUndercarriageType: number = 1
  AddGetImplementType: number = 1
  AddDigitalFormsType: number = 1
  UndercarriageContainers: InspectionReportingContainers[] = [];
  // UndercarriageContainers=[]
  GetImplementContainer: InspectionReportingContainers[] = [];
  DigitalFormsContainer: InspectionReportingContainers[] = [];
  inspections: Inspection[] = [];
  inspectionsFiltered: Inspection[] = [];
  inspectionsFiltered_: Inspection[] = [];
  inspectionsFilteredOff: Inspection[] = []
  equipmentSystems: SystemDetails[];

  ComponentDetailsList: ComponentDetails[] = []
  SystemModel: ComponentModel[] = []
  SystemModel_: ComponentModel[] = []
  SystemModelfiltered: ComponentModel[] = []
  SystemModelfiltered_: ComponentModel[] = []
  SystemModelfilteredOff: ComponentModel[] = []
  SystemModelfilteredOff_: ComponentModel[] = []

  labelLeftchain
  labelLeftFrame
  labelRightChain
  labelRightFrame
  ImplementList: Implement[]
  ImplementSerialList: ImplementSerialVM[]
  inputcost
  isLoading: boolean = false;
  isLoadingGetTable: boolean = false;
  OriginalCostsLeft: number
  OriginalCostsRight: number
  //GetImplement
  passedDate: string;
  passedDate_: string
  inspectedImplements: InspectedImplementsViewModel[];
  inspectedImplementsOFF: InspectedImplementsViewModel[];
  Components_: InspectedComponentsOnImplementViewModel[];
  implementSerial
  GetInspectionList: GETImplementVM[]
  GetInspectionList_: GETImplementVM[]
  observation: InspectionObservationPointsViewModel;
  observationOFF: InspectionObservationPointsViewModel;
  observationPointInspectionId: number
  observationPointInspectionIdOFF: number
  InspectionObservationComponents_: InspectionObservationPointsViewModel[] = [];
  InspectionObservationComponents_OFF: InspectionObservationPointsViewModel[] = [];
  ObservationList: ObservationListRental[]
  inputGetONHireInspectionDate
  inputGetOFFHireInspectionDate
  inputUndercarriageOnHitreDate
  inputUndercarriageOFFHitreDate
  inputUndercarriageSMUOn
  inputUndercarriageSMUOff
  UndercarriageImplementReport_: UndercarriageImplementReport[] = []
  undercarriageReportName = ""
  GETReportName = ""
  OnInspetionID_Undercarriage
  OnInspetionID_GET
  //generate report
  GETImplementReport_: GETImplementReport[] = []
  GETImplementReport_model: GETImplementReport[] = []
  inputImplementID: number
  TotalCostGET
  GetOnHireSMU
  GetOffHireSMU
  GetONInspetionID
  GetOFFInspetionID
  inputGetComment = ""
  inputGetCost
  originalCosts
  UndercarriageReportComment = ""
  GenerateReportID: number = 0
  isfillinde: boolean = true;
  GenerateReportIDUndercarriage: number = 0
  isReportGenerated: boolean = false
  NewFileName: string = "";
  FilePreview: string = "";
  NewFileNameGET: string = "";
  FilePreviewGET: string = "";
  isUCfileUploades:boolean=false
  isGETfileUploaded:boolean=false
  ImagePreview
  ImagePreviewGET
  isUCimageUploads:boolean=false
  isGETimageUploads:boolean=false
  ngOnInit() {
    this.GetCustomerDetails();

    this._appService.setPageTitle('Hire Report');
    //this._appService.getAppUris().subscribe(result => { this.appUris = result; });
  }


  goToStep(step: number) {
    switch (step) {
      case 1:
        this.currentStep = 1;
        break;
      case 2:
        this.currentStep = 2;
        break;
    }
  }

  goBackStep() {
    this.currentStep--;
  }


  GetCustomerDetails() {
    this._customerContactService.GetCustomerDetails().subscribe(res => {
      this.CustomerList = res;
      res.map(x => {
        x.customerName
        x.customerId
      })
      //console.log("this.customerlist",this.CustomerList);
    })
  }

  onChangeCustomer() {
    this.GetJobSiteDetails();
  }

  GetJobSiteDetails() {
    this._customerService.getCrsfInfo_().subscribe(res => {
      this.JobsiteList = res
      this.jobsitebyCustomerID = this.JobsiteList.filter(x => x.customer_auto == this.selectedCustomer);

    });
  }
  jobsiteChanged(event: any) {
    let value = event.value;
    this.selectedSiteId = event.value;
    this._fleetService.getEquipmentList(value).subscribe(result => {
      this.equipmnentList = result
      // console.log("EquipmentId",this.equipmnentList)
    })
  }


  inspecChange(event: any) {
    let value = event.value;
    this.inspectionType = value
    // if(value==1)
    // {

    //   this.InspetionLabel="Undercarriage";
    //   this.isShowUndercarriageTab=true;
    // }
    // if(value==2)
    // {
    //   this.InspetionLabel="Get Implement";    
    //   this.isShowgetImplementTab=true;

    // }
    // if(value==3)
    // {
    //   this.InspetionLabel="Digital Forms";   
    //   this.isShowDigitalFormTab=true;
    // }
  }

  loadEquipmentDetails() {
    this._manageEquipService.getEquipmentDetails(this.selectedEQId).subscribe(res => {

      this.equipmentDetails = res;
      // console.log("GetEquipmentDetails", this.equipmentDetails)
      if (this.equipmentDetails.FamilyId == 203) {
        this.IsRSH = true;
      } else {
        this.IsRSH = false;
      }
    })
    this.refresh();
  }


  getImage(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
  }

  openReportContactDialog() {
    const dialogRef = this.dialog.open(ReportContactDialogComponent, {
      disableClose: true,
      data: {

      }
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openSendEmailDialog() {
    const dialogRef = this.dialog.open(SendHirereportDialogComponent, {
      disableClose: true,
      data: {
         id: this.GenerateReportID,
         id2:this.GenerateReportIDUndercarriage
      }
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  showUndercarriageTable() {

    this.isShowUndercarriageTable = !this.isShowUndercarriageTable
  }
  showGetImplementationTable() {
    this.isShowGetImplementTable = !this.isShowGetImplementTable
  }
  showDigitalFormTable(container3: InspectionReportingContainers) {
    container3.isShowDigitalFormTable = !container3.isShowDigitalFormTable
  }

  showInspectiontypes(value:number){
    if (value == 1) {
      this.InspetionLabel = "Undercarriage";
      this.isShowUndercarriageTab = !this.isShowUndercarriageTab;
    }
    if (value == 2) {
      this.InspetionLabel = "Get Implement";
      this.isShowgetImplementTab = !this.isShowgetImplementTab;
    }
    if (value == 3) {
      this.InspetionLabel = "Digital Forms";
      this.isShowDigitalFormTab = !this.isShowDigitalFormTab;
    }
  }

  AddNewItem() {
    this.isShowUndercarriageTab = false;
    this.isShowgetImplementTab = false;
    this.isShowDigitalFormTab = false;
    if(this.inspectionType_.length>0){
      this.inspectionType_.map(x=>{
        if (x == 1) {
          this.InspetionLabel = "Undercarriage";
          this.isShowUndercarriageTab = true;
        }
        if (x == 2) {
          this.InspetionLabel = "Get Implement";
          this.isShowgetImplementTab = true;
        }
        if (x == 3) {
          this.InspetionLabel = "Digital Forms";
          this.isShowDigitalFormTab = true;
        }
      }) 
    }
    
  }

  loadEquipmentInspectionsDetails() {
    //  this._loading.startLoading();
    this._manageEquipService.getEquipmentAlltypeInspections(this.selectedEQId).subscribe(inspections => {
      this.inspections = inspections;
      this.inspectionsFiltered = inspections;
      console.log("loadEquipmentInspectionsDetails", this.inspectionsFiltered)
    });
  }

  equipmentSystemsFiltered: SystemDetails[];
  equipmentSystemsFiltered_: SystemDetails;
  ComponentsforFilter1: ComponentDetails[];
  ComponentsforFilter2: ComponentDetails[];
  ComponentsforFilter3: ComponentDetails[];
  indexarr = []
  loadEquipmentSystemsDetails() {
    // this._loading.startLoading();
     const today = new Date();
    this._manageEquipService.getEquipmentSystems(this.selectedEQId, moment(today).format('MM/DD/YYYY')).subscribe(systems => {
      this.equipmentSystems = systems;
      this.equipmentSystems.map(x => {
        if (x.Side == 'Left' && x.SystemType == 'Chain') {
          this.labelLeftchain = x.SerialNumber
        }
        if (x.Side == 'Left' && x.SystemType == 'Frame') {
          this.labelLeftFrame = x.SerialNumber
        }
        if (x.Side == 'Right' && x.SystemType == 'Chain') {
          this.labelRightChain = x.SerialNumber
        }
        if (x.Side == 'Right' && x.SystemType == 'Frame') {
          this.labelRightFrame = x.SerialNumber
        }
      })
      console.log("equipmentSystems", systems)
      if (this.equipmentSystems.length > 0) {
        this.equipmentSystemsFiltered = this.equipmentSystems.filter(x => x.Side == 'Left')
        this.ComponentsforFilter1 = this.equipmentSystemsFiltered[0].Components
        this.ComponentsforFilter2 = this.equipmentSystemsFiltered[1].Components
        this.ComponentsforFilter3 = this.ComponentsforFilter1.concat(this.ComponentsforFilter2)
        console.log("this.ComponentsforFilter3", this.ComponentsforFilter3)

        this.isLoading = true;

        this.ComponentsforFilter3.map((item, index) => {
          this.indexarr.push(index);

        });
        console.log("pushed indexex", this.indexarr)
      }


    });

  }

  filtereddate: any
  OnHireInsectionChanged(event: any) {
    let value = event.value
    console.log(this.inspectionsFiltered)
    this.inspectionsFiltered_ = this.inspectionsFiltered.filter(x => x.InspDate > value)

    console.log("Filtered lis", this.inspectionsFiltered)
    this.inputUndercarriageOnHitreDate = event.value

    // console.log(event.value)
  }

  OFFHireInsectionChanged(event: any) {
    this.inputUndercarriageOFFHitreDate = event.value
  }

  getInspectionreportingDetail(insp: Inspection) {
    this._interp.getInspectionreportingDetail(insp.Id).subscribe(system => {
      console.log("table details on", system)
      this.SystemModel = system
      this.SystemModelfiltered = this.SystemModel.filter(x => x.Side == 1 && x.IsChild == false)//left
      this.SystemModelfiltered_ = this.SystemModel.filter(x => x.Side == 2 && x.IsChild == false)//right
      let arr = [];
      this.inputUndercarriageSMUOn = insp.Smu
      this.OnInspetionID_Undercarriage = insp.Id

console.log( " this.SystemModelfiltered",this.SystemModelfiltered)

    });
  }

  worndifference = []
  rightDifference: RentInterpVM[]
  leftDifference: RentInterpVM[]
  getInspectionreportingDetailOff(insp: Inspection) {
    this.OnInspetionID_GET = insp.Id
    this.inputUndercarriageSMUOff = insp.Smu
    this._interp.getInspectionreportingDetail(insp.Id).subscribe(system => {
      console.log("table details off", system)
      this.SystemModel_ = system
      this.SystemModelfilteredOff = this.SystemModel_.filter(x => x.Side == 1 && x.IsChild == false)//leftoff
      this.SystemModelfilteredOff_ = this.SystemModel_.filter(x => x.Side == 2 && x.IsChild == false)//rightoff

      var leftdifference = [];

      for (let i = 0; i < this.SystemModelfiltered.length; i++) {
        let ob = new RentInterpVM();
        ob.Worn = Math.abs(Math.abs(this.SystemModelfiltered[i].WornPercentage - this.SystemModelfilteredOff[i].WornPercentage));

        ob.Measure = Math.abs(Math.abs(this.SystemModelfiltered[i].Measurement - this.SystemModelfilteredOff[i].Measurement));

        let value = 0;
        ob.Calc = Math.abs(value)

        //ob.Calc=0;
        //leftdifference.push(Math.abs(this.SystemModelfiltered[i].WornPercentage - this.SystemModelfilteredOff[i].WornPercentage));
        leftdifference.push(ob);
      }

      var rightdifference = [];
      for (let i = 0; i < this.SystemModelfiltered_.length; i++) {
        let ob = new RentInterpVM();
        ob.Worn = Math.abs(this.SystemModelfiltered_[i].WornPercentage - this.SystemModelfilteredOff_[i].WornPercentage);
        ob.Measure = Math.abs(this.SystemModelfiltered_[i].Measurement - this.SystemModelfilteredOff_[i].Measurement);

        let value = 0

        ob.Calc = Math.abs(value);
        ob.Input = Math.abs(value)
        //rightdifference.push(Math.abs(this.SystemModelfiltered_[i].WornPercentage - this.SystemModelfilteredOff_[i].WornPercentage));
        rightdifference.push(ob);

      }

      this.rightDifference = rightdifference
      this.leftDifference = leftdifference
      //var arr=rightdifference.concat(this.leftDifference)

      var arrCollection = [leftdifference, rightdifference, [0], [0]];

      var max = Math.max.apply(Math, arrCollection.map(function (a) {
        return a.length;
      }));

      var arrFinal = [];

      for (let i = 0; i < max; i++) {
        var arr = [];
        arrCollection.forEach(function (a) {
          arr.push(a[i]);
        });
        arrFinal.push(arr);
      }


      this.worndifference = arrFinal
      console.log("arrdifferenceright", this.worndifference)

    });
  }


  calLeft(value, event: any, row, index) {
    console.log(value, event.target.value)
    let cost = event.target.value
    let leftcal = Number(cost) * value.Worn / 100

    this.originalCosts = event.target.value
    row[0].Calc = leftcal;
    console.log("leftcal", leftcal)
    console.log(this.OriginalCostsLeft, " Left__", row[0])

  }


  calRight(value, event: any, row, index) {
    console.log(value, event.target.value)
    let cost = event.target.value
    let Rightcal = Number(cost) * value.Worn / 100

    row[1].Input = event.target.value;
    // row[3]=this.OriginalCostsRight;
    row[1].Calc = Rightcal;
    console.log("Rightcal", Rightcal)
    console.log(this.OriginalCostsLeft, " Right___", row[1])
    //this.OriginalCostsRight_.push(row[3])
  }






  totalLeftcost_ = 0
  totalRightcost_ = 0
  TotalCost_Undercarriage
  TotalCost(index) {
    var totalL = 0;
    var totalR = 0;
    var totalCost = 0;
    //var totalLeftcost;

    this.leftDifference.map(z => {
      let val = isNaN(z.Calc) ? 0 : z.Calc;
      totalL = totalL + val;
    })

    this.rightDifference.map(z => {
      let val = isNaN(z.Calc) ? 0 : z.Calc;
      totalR = totalR + val;
    })

    // var total_=0
    // total_= totalL+ totalR
    // total_.toFixed(1)
    totalCost = totalL + totalR

    this.totalLeftcost_ = totalL
    this.totalRightcost_ = totalR

    console.log("totalLeftcost_ Right", this.totalLeftcost_, this.totalRightcost_)

    // this.TotalCost_= this.totalLeftcost_+this.totalRightcost_
    this.TotalCost_Undercarriage = totalCost.toFixed(1);

    console.log("TotalCost_", this.TotalCost_Undercarriage)
  }



  equipmentChanged(event: any) {
    let value = event.value
    this._customerService.GetImplementSerial(value).subscribe(res => {
      // console.log("implment serial",res)
      this.ImplementSerialList = res
    })
  }



  GetAllImplementDetails(event: any) {
    let value = event.value
    this.inputImplementID = event.value
    this._customerService.GetImplementInspections(value).subscribe(res => {
      this.GetInspectionList = res
    })
  }

  indexArrGet = []
  GETOnHireInsectionChanged(event: any) {
    let value = event.value
    this.GetInspectionList_ = this.GetInspectionList.filter(x => x.InspectionDate > value)
    console.log("Filtered lis", this.GetInspectionList_)
    this.inputGetONHireInspectionDate = event.value
    this.indexArrGet = []
  }
  GETOFFHireInsectionChanged(event: any) {
    this.inputGetOFFHireInspectionDate = event.value
    this.indexArrGet = []
  }

 async getGETImplementDetailForTableON(insp: GETImplementVM){
   
  // const response = await this._interpretationReportService.generateGETInspectionReport(this.GETImplementReport_).toPromise();
   Promise.all([this.getGETImplementDetailForTableON_(insp)]).then((res) => {
     console.log("promise",res)
    res.map((item, index) => {
       // this.indexArrGet.push(index);
        
          });
        //  console.log("pushed indexArrGet____off1", this.indexArrGet)
   });

  }
  getGETImplementDetailForTableON_(insp: GETImplementVM) {
    this.GetOnHireSMU = insp.MeterReding
    this.GetONInspetionID = insp.InspectionID
    this.passedDate = insp.InspectionDate.toLocaleString();
    let arr = []
    //console.log(this.passedDate)
    if (this.selectedEQId > 0) {
      if (this.passedDate) {


        this._inspectionService.GetImplementInspectionsByEquipmentIdAndDate(new InspectionRequestModel(this.selectedEQId, this.passedDate)).subscribe
          (r => {
            if (r.length > 0) {
              console.log(r);
              this.inspectedImplements = r;

               this.inspectedImplements.map(x => {
                this.Components_ = x.Components

                for (let i = 0; i < this.Components_.length; i++) {
                  for (let j = 0; j < this.Components_[i].ViewObservationPointsIds.length; j++) {

                    this.observationPointInspectionId = this.Components_[i].ViewObservationPointsIds[j]

                    if (this.observationPointInspectionId > 0) {
                      this._inspectionService.getObservationPointInspection(this.observationPointInspectionId).subscribe(r => {
                        this.observation = r;
                        console.log("observation", this.observation)

                        arr.push(this.observation)
                      this.InspectionObservationComponents_ = arr
                      console.log("this.InspectionObservationComponents_", this.InspectionObservationComponents_)
                       
                      });

                    }
                  }

                }

              })

               return arr;
            }
          });       
      }

    }

  }

  worndifferenceGET = [];
  worntdifference_: RentInterpVM[]
  getGETImplementDetailForTableOFF(insp: GETImplementVM) {
    this.GetOffHireSMU = insp.MeterReding
    this.GetOFFInspetionID = insp.InspectionID
    let arr_ = []
    this.passedDate_ = insp.InspectionDate.toLocaleString();

    //console.log(this.passedDate_)
    if (this.selectedEQId > 0) {
      if (this.passedDate_) {
        this._inspectionService.GetImplementInspectionsByEquipmentIdAndDate(new InspectionRequestModel(this.selectedEQId, this.passedDate_))
          .subscribe(r => {
            //console.log(r);
            this.inspectedImplementsOFF = r;

            this.inspectedImplementsOFF.map(x => {
              this.Components_ = x.Components

              for (let i = 0; i < this.Components_.length; i++) {
                for (let j = 0; j < this.Components_[i].ViewObservationPointsIds.length; j++) {

                  this.observationPointInspectionIdOFF = this.Components_[i].ViewObservationPointsIds[j]

                  if (this.observationPointInspectionIdOFF > 0) {
                    this._inspectionService.getObservationPointInspection(this.observationPointInspectionIdOFF).subscribe(r => {
                      this.observationOFF = r;


                      arr_.push(this.observationOFF)
                      this.InspectionObservationComponents_OFF = arr_

                      //  console.log("InspectionObservationComponents_OFF----" , this.InspectionObservationComponents_OFF)
                      //  console.log("InspectionObservationComponents_On-----" , this.InspectionObservationComponents_)

                      var worntdifference = [];
                      if (this.InspectionObservationComponents_OFF.length > 0 && this.InspectionObservationComponents_.length > 0) {
                        for (let i = 0; i < this.InspectionObservationComponents_OFF.length; i++) {

                          let ob = new RentInterpVM();
                          this.InspectionObservationComponents_OFF[i].WornPercentage = this.InspectionObservationComponents_OFF[i].WornPercentage == undefined ? 0 : this.InspectionObservationComponents_OFF[i].WornPercentage == undefined ? 0 : this.InspectionObservationComponents_OFF[i].WornPercentage;
                          ob.Worn = Math.abs(Math.abs(this.InspectionObservationComponents_[i].WornPercentage - this.InspectionObservationComponents_OFF[i].WornPercentage));

                          ob.Measure = Math.abs(Math.abs(this.InspectionObservationComponents_[i].MaxReadings - this.InspectionObservationComponents_OFF[i].MaxReadings));

                          let value = 0;
                          ob.Calc = Math.abs(value)
                          ob.Input = Math.abs(value)
                          worntdifference.push(ob);
                          this.worntdifference_ = worntdifference
                          var arrCollection = [worntdifference, [0], [0]];
                          var max = Math.max.apply(Math, arrCollection.map(function (a) {
                            return a.length;
                          }));

                          var arrFinal = [];
                          for (let i = 0; i < max; i++) {
                            var arr = [];
                            arrCollection.forEach(function (a) {
                              arr.push(a[i]);
                            });
                            arrFinal.push(arr);
                          }
                          this.worndifferenceGET = arrFinal
                          if (this.worndifferenceGET.length > 0) {
                            console.log(" this.worndifferenceGET", this.worndifferenceGET)
                           this.isLoadingGetTable = true

                          }
                        }
                      }
                    });
                  }
                }
              }
             

            })

          });
      }
    }

  }


  calWornGET(value, event: any, row, index) {
    console.log(value, event.target.value)
    let cost = event.target.value
    let Worncal = Number(cost) * value.Worn / 100

    this.inputGetCost = event.target.value
    row[0].Calc = Worncal;
    row[0].Input = this.inputGetCost


    //console.log(" Left__GET", row[0])

  }



  getTotalCostGET(index) {
    var totalL = 0;
    this.worntdifference_.map(z => {
      let val = isNaN(z.Calc) ? 0 : z.Calc;
      totalL = totalL + val;
    })
    this.TotalCostGET = totalL.toFixed(1);
  }

  indexarray_GET = []
  sortedGET = []
  checkboxChangedGET(values: any, i) {
    console.log("pushed indexGET", this.indexArrGet)
    let array_ = [];
    array_ = this.indexArrGet
    if (values.checked == false) {
      const index = array_.indexOf(i);
      if (index > -1) {
        array_.splice(index, 1)

      }
    }
    else if (values.checked == true) {
      const index = array_.indexOf(i);
      if (index === -1) {
        array_.push(i)
      }
    }
    this.sortedGET = array_
    this.sortedGET.sort(function (a, b) {
      return a - b;
    });

    this.indexarray_GET = this.sortedGET
    this.indexArrGet = this.indexarray_GET
  
    console.log("this.indexarray_GET", this.indexArrGet)
  }

  //GET attachment
  AddAttachmentDialogComponentGET() {
    const dialogRef = this.dialog.open(AddAdditionalAttachmentGETComponent, {
      disableClose: true,
      data: {}
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log("dialog resuly", result)
      this.FilePreviewGET=result.data
      
        
      
    });
  }

  model_: GETImplementReport
  async generateGETInspectionReport() {
    let arr_get = []
    for (let i = 0; i < this.indexArrGet.length; i++) {
      let model = new GETImplementReport();
      model.ComponentId = this.InspectionObservationComponents_[this.indexArrGet[i]].ComponentId
      model.ComponentName = this.InspectionObservationComponents_[this.indexArrGet[i]].ComponentName
      model.ComponentType = this.InspectionObservationComponents_[this.indexArrGet[i]].ComponentType
      model.ComponentTypeId = this.InspectionObservationComponents_[this.indexArrGet[i]].ComponentTypeId
      model.EquipmentID = this.selectedEQId
      model.ImplementID = this.inputImplementID
      model.ObservationTypeId = this.InspectionObservationComponents_[this.indexArrGet[i]].ObservationTypeId
      model.ObservationName = this.InspectionObservationComponents_[this.indexArrGet[i]].ObservationName
      model.WornPercentageOn = this.InspectionObservationComponents_[this.indexArrGet[i]].WornPercentage
      model.WornPercentageOff = this.InspectionObservationComponents_OFF[this.indexArrGet[i]].WornPercentage
      model.WornPercentageDiff = this.worndifferenceGET[this.indexArrGet[i]][0].Worn
      model.cost = this.worndifferenceGET[this.indexArrGet[i]][0].Input
      // model.cost=Number(this.inputGetCost)
      model.ONHireDate = this.inputGetONHireInspectionDate
      model.OFFHireDate = this.inputGetOFFHireInspectionDate
      model.SMUoN = this.GetOnHireSMU
      model.SMUOff = this.GetOffHireSMU
      model.totalCost = this.TotalCostGET
      model.comment = this.inputGetComment
      model.chargedCostValue = this.worndifferenceGET[this.indexArrGet[i]][0].Calc
      model.ONInspectionId = this.GetONInspetionID
      model.OFFInspectionId = this.GetOFFInspetionID
      model.ObservationId = this.InspectionObservationComponents_[this.indexArrGet[i]].ObservationPointId
      model.ReportName = this.GETReportName
      var sImageUrl = this.FilePreviewGET.replace(/^data:image\/[a-z]+;base64,/, "");
      sImageUrl = this.FilePreviewGET.replace(/^data:image\/\w+;base64,/, "");
      model.Attachment = this.FilePreviewGET
      model.Image= this.ImagePreviewGET
      this.model_ = model
      arr_get.push(this.model_)
    }
    console.log("arr_get", arr_get)
    this.GETImplementReport_ = arr_get
    const response = await this._interpretationReportService.generateGETInspectionReport(this.GETImplementReport_).toPromise();
    Promise.all([response]).then((res) => {
      this.GenerateReportID = res[0]
      this.GeneratePDF(this.GenerateReportID, this.GenerateReportIDUndercarriage)
    });

  }

  indexarray_ = []
  sorted = []
  checkboxChangedUndercarriage(values: any, i) {
    console.log("pushed indexex", this.indexarr)
    let array_ = [];
    array_ = this.indexarr
    if (values.checked == false) {
      const index = array_.indexOf(i);
      if (index > -1) {
        array_.splice(index, 1)

      }
    }
    else if (values.checked == true) {
      const index = array_.indexOf(i);
      if (index === -1) {
        array_.push(i)
      }
    }
    this.sorted = array_
    this.sorted.sort(function (a, b) {
      return a - b;
    });

    this.indexarray_ = this.sorted
    this.indexarr = this.indexarray_
    console.log("this.indexarray_", this.indexarr)
  }

    //UC attachment
    AddAttachmentDialogComponent() {
      const dialogRef = this.dialog.open(AddAdditionalAttachmentComponent, {
        disableClose: true,
        data: {}
      });
      dialogRef.afterClosed().subscribe(result => {
        console.log("dialog resuly", result)
        this.FilePreview=result.data
        
          this.isUCfileUploades=true
        console.log( this.isUCfileUploades)
        
      });
    }

  ComponentsforFilter: ComponentDetails[] = []
  modelUnder_: UndercarriageImplementReport
  async generateUndercarriageReport() {
    //save Undercarriage data
    let arr = []
    for (let i = 0; i < this.indexarr.length; i++)
    //for(let i=0; i<this.SystemModelfiltered.length; i++)
    {
      let model = new UndercarriageImplementReport();

      model.componentName = this.SystemModelfiltered[this.indexarr[i]].Name
      model.CompartId = this.SystemModelfiltered[this.indexarr[i]].ComponentId
      model.EquipmentID = this.selectedEQId
      model.ONHireDate = this.inputUndercarriageOnHitreDate
      model.OFFHireDate = this.inputUndercarriageOFFHitreDate
      model.SMUoN = this.inputUndercarriageSMUOn
      model.SMUOff = this.inputUndercarriageSMUOff
      model.leftWornPercentageON = this.SystemModelfiltered[this.indexarr[i]].WornPercentage
      model.rightWornPercentageON = this.SystemModelfiltered_[this.indexarr[i]].WornPercentage
      model.leftWornPercentageOFF = this.SystemModelfilteredOff[this.indexarr[i]].WornPercentage
      model.roghtWornPercentageOFF = this.SystemModelfilteredOff_[this.indexarr[i]].WornPercentage


      model.leftMeasurementON = this.SystemModelfiltered[this.indexarr[i]].Measurement
      model.rightMeasurementON = this.SystemModelfiltered_[this.indexarr[i]].Measurement
      model.leftMeasurementOFF = this.SystemModelfilteredOff[this.indexarr[i]].Measurement
      model.roghtMeasurementOFF = this.SystemModelfilteredOff_[this.indexarr[i]].Measurement


      model.leftPctUsed = this.worndifference[this.indexarr[i]][0].Worn
      model.rightPctUsed = this.worndifference[this.indexarr[i]][1].Worn

      model.leftMeasureUsed = this.worndifference[this.indexarr[i]][0].Worn
      model.rightMeasureUsed = this.worndifference[this.indexarr[i]][1].Worn

      model.originalCosts = this.worndifference[this.indexarr[i]][1].Input
      //model.originalCosts=Number(this.originalCosts)
      model.leftCost = this.worndifference[this.indexarr[i]][0].Calc
      model.rightCost = this.worndifference[this.indexarr[i]][1].Calc
      model.totalCost = Number(this.TotalCost_Undercarriage)
      model.comment = this.UndercarriageReportComment
      model.ReportName = this.undercarriageReportName
      model.ONInspectionId = this.OnInspetionID_Undercarriage
      model.OFFInspectionId = this.OnInspetionID_GET//off  

      var sImageUrl = this.FilePreview.replace(/^data:image\/[a-z]+;base64,/, "");
      sImageUrl = this.FilePreview.replace(/^data:image\/\w+;base64,/, "");
      model.Attachment = this.FilePreview
      model.inspection_auto = 1
      
      model.Image=this.ImagePreview


      this.modelUnder_ = model
      // console.log("modelUnder_", this.modelUnder_)
      arr.push(this.modelUnder_)
    }

    this.UndercarriageImplementReport_ = arr
    console.log("this.UndercarriageImplementReport_", this.UndercarriageImplementReport_)

    const response = await this._interpretationReportService.generateUndercarriageInspectionReport(this.UndercarriageImplementReport_).toPromise();

    Promise.all([response]).then((res) => {
      this.GenerateReportIDUndercarriage = res[0]
      this.generateGETInspectionReport()
    });
  }

  GeneratePDF(id: number, id2: number) {
    //window.open(this.appUris.UCUri + 'api/RentalInterp/GetPdf?id=' + id + '&id2=' + id2, '_blank');
    window.open(this._appService.getBaseURL() + 'api/RentalInterp/GetPdf?id=' + id + '&id2=' + id2, '_blank');
    this.isReportGenerated=true
  }

  
  refresh() {
    this.ComponentsforFilter3 = [];
    this.SystemModelfiltered = [];
    this.SystemModelfiltered_ = [];
    this.SystemModelfilteredOff = [];
    this.SystemModelfilteredOff_ = [];
    this.worndifference = [];
  }
  
  onImageChanged(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); // read file as data url
      reader.onload = (event) => { // called once readAsDataURL is completed
          var imageUrl = (event.target["result"]);
         //console.log("imageUrl",imageUrl)
          this.ImagePreview = imageUrl;
         this.isUCimageUploads=true
      }
  }
  }
  onImageChangedGET(event) {

    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); // read file as data url
      //reader.onload = (event:FileReaderEvent) => { // called once readAsDataURL is completed
      reader.onload = (event) => { // called once readAsDataURL is completed
          var imageUrl = (event.target["result"]);
         console.log("imageUrl",imageUrl)
          this.ImagePreviewGET = imageUrl;
         this.isGETimageUploads=true
      }
  }
  }
}
